// Get the last of the nodes
r.prototype.last = function() {
    return this.nodes[this.length - 1] || false;
};
